import React from 'react';
import styled from '@emotion/styled';
import { Accordion } from '@naf-simba/elements-accordion';
import { spacing } from '@naf/theme';
import { PortableTextBlock } from '@portabletext/react';
import BlockContent from '../../../BlockContent';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface AccordionSerializerProps {
  value: { text: PortableTextBlock[]; title: string };
}

export const AccordionBlock = ({ value: { text, title } }: AccordionSerializerProps) => (
  <Accordion headingLevel={3} title={title} className="accordion">
    <AccordionContent>
      <BlockContent value={text} />
    </AccordionContent>
  </Accordion>
);

export const AccordionSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: AccordionSerializerProps) => (
      <ArticleBlockContentGridCol className="blockAccordion">
        <AccordionBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: AccordionSerializerProps) => <AccordionBlock value={value} />;
};

const AccordionContent = styled.div`
  p {
    margin: 0;
  }
  p:not(:last-child) {
    margin-bottom: ${spacing.space16};
  }
`;
